








































































































import { Component, Inject, Prop, Vue, Watch } from 'vue-property-decorator';
import VueUploadComponent from 'vue-upload-component';
import uuid from 'uuid/v4';

@Component({
  components: { 'file-upload': VueUploadComponent },
})
export default class FileUploadWidget extends Vue {

  @Inject()
  public $validator: any;

  @Prop(Array)
  public filesProp!: any[];
  @Prop(String)
  public uploadButtonText!: string;
  @Prop(String)
  public uploadButtonHtml!: string;
  @Prop(String)
  public accept!: string;
  @Prop(String)
  public name!: string;
  @Prop(String)
  public inputName!: string;
  @Prop({ type: String, default: 'jpg,jpeg,png,pdf' })
  public extensions!: string | string[];
  @Prop(String)
  public postAction!: string;
  @Prop(String)
  public putAction!: string;
  @Prop(String)
  public btnClass!: string;
  @Prop(String)
  public additionalText!: string;
  @Prop(String)
  public additionalHtml!: string;
  @Prop(String)
  public staticInputId!: string;
  @Prop({ type: String, default: 'payrollForm' })
  public formName!: string;
  @Prop(Number)
  public minSize!: number;
  @Prop(Number)
  public sizeInMb!: number;
  @Prop(Number)
  public timeout!: number;
  @Prop({ type: Number, default: 3 })
  public maximum!: number;
  @Prop(Number)
  public arrayIndex!: number;
  @Prop(Number)
  public thread!: number;
  @Prop(Number)
  public autoCompress!: number;
  @Prop(Boolean)
  public multiple!: boolean;
  @Prop({ type: Boolean, default: true })
  public drop!: boolean;
  @Prop(Boolean)
  public directory!: boolean;
  @Prop(Boolean)
  public dropDirectory!: boolean;
  @Prop(Boolean)
  public addIndex!: boolean;
  @Prop(Boolean)
  public uploadAuto!: boolean;
  @Prop(Boolean)
  public isOptionl!: boolean;
  @Prop(Boolean)
  public removeDefaultUsage!: boolean;
  @Prop(Boolean)
  public hideUploadWhenFilesAdded!: boolean;
  @Prop(Boolean)
  public showWarningIcon!: boolean;
  @Prop(Boolean)
  public isRequired!: boolean;
  @Prop(Boolean)
  public isReadOnly!: boolean;
  @Prop({ type: Boolean, default: false })
  public hideDownload!: boolean;
  @Prop({ type: Boolean, default: false })
  public hideTrash!: boolean;
  @Prop(Boolean)
  public showDefaultAlways!: boolean;

  private inputId: string = '';
  private size: number = 0;
  private isError: boolean = false;
  private isDragging: boolean = false;
  private errorMessage: string = '';
  private files: any[] = [];

  public created() {
    this.inputId = 'input' + this.staticInputId || 'input' + uuid();
    if (this.formName && !this.staticInputId) {
      this.inputId = this.formName + '.' + this.inputId;
    }
    if (this.isRequired) {
      const missingFileSelection = this.$t('missingFileSelection');
      this.$validator.extend('fileSelected',
        {
          getMessage: (field: any) => {
            return '' + missingFileSelection;
          },
          validate: (files: any) => {
            return files.length > 0;
          },
        });
    }
  }

  public mounted() {
    this.files = [...this.filesProp || []];
    if (this.sizeInMb) {
      this.size = this.sizeInMb * 1024 * 1024;
    }
  }

  public openFileDialog() {
    document.getElementById(this.inputId)!.click();
  }

  public dragEnter(e: any) {
    this.isDragging = true;
  }

  public dragLeave(e: any) {
    this.isDragging = false;
  }

  public onDrop(e: any) {
    this.isDragging = false;
  }

  public inputFilter(newFile: any, oldFile: any, prevent: any) {
    if (
      this.extensions && this.extensions.indexOf(newFile.name.split('.')
        .pop().toLowerCase()) === -1
    ) {
      this.errorMessage = this.$t('file_upload.extensions_error_message').toString();
      this.isError = true;
      return prevent();
    } else if (newFile.size >= 0 && newFile.size > this.size) {
      this.isError = true;
      this.errorMessage = this.$t('file_upload.size_error_message').toString();
      return prevent();
    } else if (/\.(jpeg|jpe|jpg|gif|png|webp)$/i.test(newFile.name)) {
      // Create a blob field
      newFile.blob = '';

      // @ts-ignore
      const URL = window.URL || window.webkitURL;
      if (URL && URL.createObjectURL) {
        newFile.blob = URL.createObjectURL(newFile.file);
      }
    }
  }

  // add, update, remove File Event
  public async inputFile(newFile: any, oldFile: any) {
    if (this.maximum !== 0 && this.files.length >= this.maximum && newFile && !oldFile) {
      this.errorMessage = this.$t('file_upload.maximum_error_message').toString();
      this.isError = true;
    } else if (newFile && !oldFile && !this.fileExists(newFile)) {
      newFile.arrayIndex = this.arrayIndex;
      this.isError = false;
      this.errorMessage = '';
      const name: string = newFile.name;
      if (/\.(jpeg|jpe|jpg|gif|png|webp)$/i.test(name)) {
        const blobFile: Blob = await this.resizeImage(newFile.file);
        if (!navigator.msSaveBlob) { // detect if not Edge
          newFile.file = new File([blobFile], name, { type: newFile.type });
        } else {
          newFile.file = new Blob([blobFile], { type: newFile.type });
        }
        newFile.name = name;
        newFile.size = blobFile.size;
      }
      this.$emit('onInputFile', newFile, this.staticInputId || this.inputId);
    }
  }

  public resizeImage(file: Blob): Promise<Blob> {
    const reader = new FileReader();
    const image = new Image();
    const canvas = document.createElement('canvas');
    const dataURItoBlob = (dataURI: string) => {
      const bytes =
        dataURI.split(',')[0].indexOf('base64') >= 0
          ? atob(dataURI.split(',')[1])
          : unescape(dataURI.split(',')[1]);
      const mime = dataURI
        .split(',')[0]
        .split(':')[1]
        .split(';')[0];
      const max = bytes.length;
      const ia = new Uint8Array(max);
      for (let i = 0; i < max; i++) {
        ia[i] = bytes.charCodeAt(i);
      }

      return new Blob([ia], { type: mime });
    };
    const resize = () => {
      canvas.width = image.width;
      canvas.height = image.height;
      const context = canvas.getContext('2d');
      if (context != null) {
        context.drawImage(image, 0, 0);
      }

      const dataUrl = canvas.toDataURL('image/jpeg', 0.5);

      return dataURItoBlob(dataUrl);
    };

    return new Promise((ok, error) => {
      reader.onload = (readerEvent: any) => {
        image.onload = () => ok(resize());
        image.src = readerEvent.target.result;
      };
      reader.readAsDataURL(file);
    });
  }

  @Watch('filesProp')
  public onFilesPropChanged(newVal: any, oldVal: any) {
    this.files = newVal;
  }

  public openDeleteDialog(index: number) {
    if (this.files[index].docId) {
      this.$root.$emit('openDeleteFileDialog', this.files[index]);
    } else if(this.files[index]){
      this.$emit('deleteFile', this.files[index]);
    }
    if (this.maximum !== 0 && this.files.length <= this.maximum) {
      this.isError = false;
    }
  }

  public downloadFile(index: number) {
    if (this.files[index].docId) {
      this.$emit('onDownloadClicked', this.files[index]);
    }
  }

  public fileExists(file: any) {
    for (const fileProp of this.filesProp) {
      if (file.id === fileProp.id) {
        return true;
      }
    }
    return false;
  }

  get validators(): any {
    if (this.isRequired) {
      return {
        fileSelected: true,
        required: true,
      };
    }
    return null;
  }

}
